module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-3.77062773.jpg";